export const WelcomeItems = {
    title: 'Computer Engineer',
    des: 'Third Year Computer Engineering Student. \
    Experienced in Cloud Infrastructures and Embedded Software.  \
    Interested in Data Science and Application Development.'
}